// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__VhB1F","remainingCharacters":"Textarea_remainingCharacters__BsKAt"};